import type { ClientTextLinkProps } from '@fukku/text-link/client/ClientTextLink'
import { cx } from 'classix'
import type { RefObject } from 'react'
import { ClientLink } from 'utils/link/client/ClientLink'

import styles from './CommBannerLinkWrapper.module.css'

interface CommBannerLinkWrapperProps {
	readonly tabIndex: -1 | undefined
	readonly commRef: RefObject<HTMLDivElement | null>
	readonly colorStyle: Record<string, unknown>
	readonly wrapperClassName: string
	readonly children: React.ReactNode
	readonly firstLink?: ClientTextLinkProps
}
export function CommBannerLinkWrapper({
	tabIndex,
	commRef,
	colorStyle,
	wrapperClassName,
	children,
	firstLink,
}: CommBannerLinkWrapperProps) {
	const hasOnlyOneLink = firstLink?.href && firstLink?.children
	const isHashLink = firstLink?.href?.startsWith('#')

	if (hasOnlyOneLink && isHashLink) {
		return (
			<div ref={commRef} data-testid='CommBannerHashLinkWrapper'>
				<a
					href={firstLink.href}
					onClick={firstLink.onClick}
					className={cx(wrapperClassName, styles.noUnderline, styles.link)}
					style={colorStyle}
				>
					{children}
				</a>
			</div>
		)
	}

	if (hasOnlyOneLink) {
		return (
			<div ref={commRef} data-testid='CommBannerLinkWrapper'>
				<ClientLink
					{...firstLink}
					linkProps={{
						...firstLink.linkProps,
						title: firstLink.children as string,
						className: cx(wrapperClassName, styles.noUnderline, styles.link),
						style: colorStyle,
						tabIndex,
					}}
					href={firstLink?.href}
				>
					{children}
				</ClientLink>
			</div>
		)
	}

	return (
		<div
			ref={commRef}
			data-testid='CommBannerNoLinkWrapper'
			className={wrapperClassName}
			style={colorStyle}
		>
			{children}
		</div>
	)
}
